module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAAAiUlEQVRoge3WMQqAMBQE0UQ8S+5/neQy2ggWQUyZWeY1Nh9hsHBr7/0q/+rzRNweCy/DMYrCKAqjKCKjzvL+1FZsd9tamw5ivxRi+nzdjjGmw8gvZRSFURRGUURGOZMonEkURlEYRWEURWSUM4nCmURhFIVRFEZRREY5kyicSRRGURhFYRRFZNQNmZYoFKTA1lUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/allEqualTwentyFifths.png
// module id = HRUS
// module chunks = 0